import { type BaseNotificationItemProps, NotificationItem } from '../components/NotificationItem'

export type ProgramUpdatedProps = BaseNotificationItemProps & {
  name: string
  attribute: string
  type: 'program-updated'
}

export function ProgramUpdated({ name, attribute, ...props }: ProgramUpdatedProps) {
  return (
    <NotificationItem
      {...props}
      title={`${name} Configuration Updated`}
      descriptionAddon={<p className='flex text-sm text-gray-500'>{`"${attribute}" was updated.`}</p>}
    />
  )
}
